import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {"white-space":"normal","word-break":"break-word","line-height":"1.3"} }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "column" }
const _hoisted_7 = {
  key: 0,
  class: "q-mt-sm q-pa-sm",
  style: {"background":"#f5f5f5","border-radius":"4px","font-size":"12px","line-height":"1.4"}
}
const _hoisted_8 = { class: "q-mt-xs" }
const _hoisted_9 = { class: "text-grey-7" }
const _hoisted_10 = { class: "column" }
const _hoisted_11 = { class: "col q-pb-sm" }
const _hoisted_12 = {
  class: "column",
  style: {"max-height":"300px","overflow-y":"auto"}
}
const _hoisted_13 = { class: "col q-pb-sm" }
const _hoisted_14 = { class: "text-h6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_PigRunSummary = _resolveComponent("PigRunSummary")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_QueuedCommandsList = _resolveComponent("QueuedCommandsList")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_time = _resolveComponent("q-time")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_option_group = _resolveComponent("q-option-group")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_card, {
      square: "",
      flat: "",
      bordered: "",
      class: "my-card bg-grey-1 vertical-bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar_title, { class: "text-weight-bold text-grey-brand" }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode("Download Manager", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_q_btn, {
              flat: "",
              round: "",
              dense: "",
              icon: "close",
              onClick: _ctx.onDownloadManagerCloseClick
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_q_select, {
                modelValue: _ctx.selectedDownloadType,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDownloadType) = $event)),
                  _ctx.onDownloadTypeSelect
                ],
                dense: "",
                color: "blue-brand",
                outlined: "",
                options: _ctx.downloadTypeOptions,
                label: "Select Download Type"
              }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
            ])
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.completedPigRuns.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_q_select, {
                      modelValue: _ctx.selectedCompletedPigRun,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCompletedPigRun) = $event)),
                        _ctx.onCompletedPigRunSelect
                      ],
                      dense: "",
                      color: "blue-brand",
                      outlined: "",
                      clearable: "",
                      options: _ctx.completedPigRunOptions,
                      label: "Select Completed Pig Run",
                      "popup-content-style": "white-space: normal; word-break: break-word;",
                      onClear: _ctx.onCompletedPigRunClear
                    }, {
                      "selected-item": _withCtx((scope) => [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(scope.opt.label), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options", "onUpdate:modelValue", "onClear"]),
                    _createVNode(_component_PigRunSummary, {
                      ref: "pigRunSummary",
                      "pig-run-id": _ctx.selectedCompletedPigRunId,
                      onLoaded: _ctx.onPigRunSummaryLoaded
                    }, null, 8, ["pig-run-id", "onLoaded"]),
                    _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                    _createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "Download Recorded Passage Data",
                      dense: "",
                      "no-caps": "",
                      disable: !_ctx.selectedCompletedPigRun,
                      onClick: _ctx.onCompletedPigRunDownloadRecordedPassageDataClick
                    }, null, 8, ["disable", "onClick"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, "There are no completed pig runs to download from."))
            ])
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.showDownloadTypeCompletedPigRun]
        ]),
        _withDirectives(_createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_q_btn, {
                class: "btn-brand",
                label: "Enter download parameters",
                dense: "",
                "no-caps": "",
                onClick: _ctx.onEnterParametersForDevicesDownloadClick
              }, null, 8, ["onClick"]),
              (_ctx.hasDevicesDownloadParameters)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-bold q-mb-xs" }, "Parameters", -1)),
                    _createElementVNode("div", null, [
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-grey-7" }, "Start:", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.startDateDevicesDownload), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-grey-7" }, "End:", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.endDateDevicesDownload), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, "AGMs (" + _toDisplayString(_ctx.selectedDevicesForDevicesDownload.length) + "):", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.truncatedDeviceLabelsForDevicesDownload) + " ", 1),
                      (_ctx.selectedDevicesForDevicesDownload.length > 5)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "#",
                            style: {"font-size":"11px"},
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.showAllAgmsSummary = !_ctx.showAllAgmsSummary), ["prevent"]))
                          }, _toDisplayString(_ctx.showAllAgmsSummary ? 'Show less' : 'Show all'), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_q_btn, {
                class: "btn-brand",
                label: "Download Recorded Passage Data",
                dense: "",
                "no-caps": "",
                onClick: _ctx.onDevicesDownloadRecordedPassageDataClick
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.showDownloadTypeDevice]
        ]),
        _createVNode(_component_q_separator),
        _createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createVNode(_component_QueuedCommandsList, {
              active: _ctx.showDownloadManager,
              "can-show-sessions": _ctx.canShowDownloadSessions,
              onShowSessions: _ctx.onShowDownloadSessionsClick
            }, null, 8, ["active", "can-show-sessions", "onShowSessions"]),
            (_ctx.canShowDownloadSessions)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  class: "btn-brand q-mt-sm",
                  label: "Show download sessions",
                  dense: "",
                  "no-caps": "",
                  "data-test": "show-download-sessions",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onShowDownloadSessionsClick()))
                }, {
                  default: _withCtx(() => [
                    (_ctx.downloadSessionCountBadge !== null)
                      ? (_openBlock(), _createBlock(_component_q_badge, {
                          key: 0,
                          color: "white",
                          "text-color": "blue-brand",
                          floating: "",
                          label: _ctx.downloadSessionCountBadge
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showEnterParametersForDevicesDownloadDialog,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showEnterParametersForDevicesDownloadDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"600px","max-width":"90vm"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createTextVNode("Download Parameters", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.startDateDevicesDownload,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.startDateDevicesDownload) = $event)),
                      dense: "",
                      filled: "",
                      label: "Start Date (UTC)"
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "event",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              ref: "qStartDateProxy",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_date, {
                                  modelValue: _ctx.startDateDevicesDownload,
                                  "onUpdate:modelValue": [
                                    _cache[4] || (_cache[4] = ($event: any) => ((_ctx.startDateDevicesDownload) = $event)),
                                    _ctx.hideStartDateProxy
                                  ],
                                  mask: "YYYY-MM-DD HH:mm:ss"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        })
                      ]),
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "access_time",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              ref: "qStartTimeProxy",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_time, {
                                  modelValue: _ctx.startDateDevicesDownload,
                                  "onUpdate:modelValue": [
                                    _cache[5] || (_cache[5] = ($event: any) => ((_ctx.startDateDevicesDownload) = $event)),
                                    _ctx.hideStartTimeProxy
                                  ],
                                  mask: "YYYY-MM-DD HH:mm:ss",
                                  format24h: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.endDateDevicesDownload,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.endDateDevicesDownload) = $event)),
                      dense: "",
                      filled: "",
                      label: "End Date (UTC)"
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "event",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              ref: "qEndDateProxy",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_date, {
                                  modelValue: _ctx.endDateDevicesDownload,
                                  "onUpdate:modelValue": [
                                    _cache[7] || (_cache[7] = ($event: any) => ((_ctx.endDateDevicesDownload) = $event)),
                                    _ctx.hideEndDateProxy
                                  ],
                                  mask: "YYYY-MM-DD HH:mm:ss"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        })
                      ]),
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "access_time",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              ref: "qEndTimeProxy",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_time, {
                                  modelValue: _ctx.endDateDevicesDownload,
                                  "onUpdate:modelValue": [
                                    _cache[8] || (_cache[8] = ($event: any) => ((_ctx.endDateDevicesDownload) = $event)),
                                    _ctx.hideEndTimeProxy
                                  ],
                                  mask: "YYYY-MM-DD HH:mm:ss",
                                  format24h: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createVNode(_component_q_separator),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_q_option_group, {
                      modelValue: _ctx.selectedDevicesForDevicesDownload,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedDevicesForDevicesDownload) = $event)),
                      dense: "",
                      options: _ctx.allDeviceOptionsForDevicesDownload,
                      color: "indigo-9",
                      type: "checkbox"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createVNode(_component_q_separator),
                _createVNode(_component_q_card_actions, { align: "right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "Set Parameters",
                      type: "button",
                      "no-caps": "",
                      onClick: _ctx.onSetParametersForDevicesDownloadClick
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showValidationMessageDialog,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showValidationMessageDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.validationDialogTitle), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.validationDialogMessage), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: "OK",
                  color: "primary"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 512)), [
    [_vShow, _ctx.showDownloadManager]
  ])
}